var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"el-no-data"},[_c('img',{staticClass:"empty-img",attrs:{"src":require("@/static/nonebook.png")}}),_vm._t("datatitle")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }